export const ListQueryKey = 'shipAddresss';
export const DetailQueryKey = 'shipAddress';
export const Urls = {
  selectUrl: '/shoppingAddress/list',
  updateUrl: '/shoppingAddress/update',
  deleteUrl: '/shoppingAddress/delete',
  createUrl: '/shoppingAddress/create',
  detailUrl: '/shoppingAddress/detail'
}; // /api/shoppingAddress/list